import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

import { Title } from '@angular/platform-browser';

import { FleetChecklistStoreService } from '../../store/fleet-checklist-store.service';
import { VehicleValidationEditorService } from '../../services/vehicle-validation-editor.service';
import { FleetChecklistEditorService } from '../../services/fleet-checklist-editor.service';

import { FleetStatus } from '../../models/fleet-checklist';

@Component({
  selector: 'app-fleet-checklist-view',
  templateUrl: './fleet-checklist-view.component.html',
  styleUrls: ['./fleet-checklist-view.component.scss', '../../styles/styles-component.scss']
})
export class FleetChecklistViewComponent implements OnInit {
  fleetChecklistId: string = '';

  searchTerm: string = '';
  autoMarking = false;

  globalOptions: {[key: string] : any} = {};

  editableOptions: any = []
  finalizedOptions: any = []

  constructor(
    public store: FleetChecklistStoreService,
    public fleetEditor: FleetChecklistEditorService,
    public vehicleEditor: VehicleValidationEditorService,
    private route: ActivatedRoute,
    private titleService: Title
  ) { }

  isModified$ = this.vehicleEditor.isModified$;
  autoMarking$ = this.vehicleEditor.autoMarking$;
  countdown$ = this.vehicleEditor.countdown$;


  get fleetChecklist() {
    return this.store.fleetChecklist$;
  }


  private actionsMap = {
    modifyValidation: {
      label: 'Modificar Validación',
      icon: 'pi pi-pencil',
      command: () => {
        this.onSaveValidation();
        const summary = this.store.getSummary();
        if (summary) this.fleetEditor.openToEdit(summary);
      }
    },

    generateReport: {
      label: 'Descargar Reporte PDF',
      icon: 'pi pi-file-pdf',
      command: async (context?: any) => {
        let isSaved = await this.onSaveValidation();
        if (context === 'editable') {
          this.onSendValidation();
        }

        const toast = Swal.fire({
          title: 'Descargando reporte...',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        const ok = await this.store.downloadReport();

        Swal.close();

        if (!ok) {
          Swal.fire({
            title: 'Error al generar el reporte',
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 2000,
            showConfirmButton: false
          });
        }
      }
    },


    openValidation: {
      label: 'Reabrir Validación',
      icon: 'pi pi-folder-open',
      command: () => this.onOpenValidation()
    },

    sendValidation: {
      label: 'Enviar Validación',
      icon: 'pi pi-send',
      command: () => this.onSendValidation()
    },

    sendValidationPDF : {
      label: 'Enviar Validación con PDF adjunto',
      icon: 'pi pi-envelope',
      command: () => this.onSendValidation(true)
    }
  };

  ngOnInit(): void {
    this.autoMarking$?.subscribe(value => this.autoMarking = value);

    this.route.paramMap.subscribe(params => {
      const id = params.get('id') || '';
      if (!id) this.goToList()
      else {
        this.fleetChecklistId = id;
        this.store.initialize(id)
      }
    });

    this.editableOptions = [
      this.actionsMap.modifyValidation,
      this.actionsMap.generateReport,
      this.actionsMap.sendValidation,
      this.actionsMap.sendValidationPDF,
    ];

    this.finalizedOptions = [
      this.actionsMap.generateReport,
      this.actionsMap.sendValidationPDF,
      this.actionsMap.openValidation
    ];

    this.titleService.setTitle('Validación de Flota - GL Tracker');
  }

  toggleAutoMarking(): void {
    this.vehicleEditor.toggleAutoMarking();
  }

  async onOpenValidation() {
    Swal.fire({
      title: '¿Deseas reabrir la validación?',
      text: 'El checklist volverá al estado de validación en proceso.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, reabrir',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let saved = await this.store.updateChecklistStatus(FleetStatus.IN_PROGRESS);
        if (saved) {
          Swal.fire({
            title: 'Validación reabierta correctamente',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
          })
        } else {
          Swal.fire({
            title: 'No se pudo reabrir la validación',
            text: 'Ocurrió un error al actualizar el estado del checklist.',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      }
    })
  }
  async onSendValidation(withPDF = false) {
    Swal.fire({
      title: '¿Enviar validación?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar'
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          await this.onSaveValidation();
          let saved = await this.store.sendFleetChecklist(withPDF);
          if (saved) {
            Swal.fire({
              title: 'Validación enviada',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
          } else {
            Swal.fire({
              title: 'Error al enviar la validación',
              icon: 'error',
              timer: 1500,
              showConfirmButton: false
            });
          }
        }
      });
  }
  onFinishValidation() {
    if(this.vehicleEditor.isVehiclesCompleted()){
      Swal.fire({
        title: '¿Finalizar validación?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Finalizar',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          let saved = await this.vehicleEditor.onFinishValidation();
          if (saved) {
            Swal.fire({
              title: 'Validación finalizada',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              this.store.initialize(this.fleetChecklistId)
            });
          } else {
            Swal.fire({
              title: 'Error al finalizar la validación',
              icon: 'error',
              timer: 1500,
              showConfirmButton: false
            });
          }
        }
      })
    } else {
      Swal.fire({
        title: 'Existen vehículos sin validar',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar'
      })
    }
  }
  async onSaveValidation() : Promise<boolean> {
    return this.vehicleEditor.onSaveValidation();
  }
  onSearchChange() {
    this.vehicleEditor.setSearchTerm(this.searchTerm);
  }
  onUpdated(event: any) {
    this.store.initialize(this.fleetChecklistId)
    console.log('Updated', this.fleetChecklistId);
  }
  // utils
  goToList() {
    //this.router.navigate(['/validation']);
  }

  getCompletedVehiclesCount(vehicles: any[] | null): number {
    if (!vehicles) return 0;
    return vehicles.filter(v => v.status === 'completed' || v.status === 'inReview' || v.status === 'observation').length;
  }

  getProgressPercentage(vehicles: any[] | null): number {
    if (!vehicles || vehicles.length === 0) return 0;
    const completed = this.getCompletedVehiclesCount(vehicles);
    return Math.round((completed / vehicles.length) * 100);
  }

}
